export const modalKeys = {
    dropdown: 'dropdown-edit-list',
    transfer: 'transfer-edit-list'
};
